import { graphql } from 'gatsby'

export { default } from './JobsDescription'

export const query = graphql`
  query MyQuery($language: String, $slug: String) {
    contentfulJobOffer(node_locale: { eq: $language }, slug: { eq: $slug }) {
      title
      slug
      node_locale
      location {
        name
      }
      type {
        name
      }
      department {
        slug
        name
      }
      description {
        title
        bullets
        description {
          description
        }
      }
    }
  }
`
